import { render, staticRenderFns } from "./SvgExtractModal.vue?vue&type=template&id=7edfcb4e&scoped=true"
import script from "./SvgExtractModal.vue?vue&type=script&lang=js"
export * from "./SvgExtractModal.vue?vue&type=script&lang=js"
import style0 from "./SvgExtractModal.vue?vue&type=style&index=0&id=7edfcb4e&scoped=true&lang=css"
import style1 from "./SvgExtractModal.vue?vue&type=style&index=1&id=7edfcb4e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edfcb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edfcb4e')) {
      api.createRecord('7edfcb4e', component.options)
    } else {
      api.reload('7edfcb4e', component.options)
    }
    module.hot.accept("./SvgExtractModal.vue?vue&type=template&id=7edfcb4e&scoped=true", function () {
      api.rerender('7edfcb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgExtractModal.vue"
export default component.exports